<script>
export default {
  components: {},
  props: {
    group: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      shareVaultConfirm: false,
    }
  },
  computed: {},

  methods: {
    getStarted() {
      this.$emit('getStarted')
    },
    closeDialog() {
      this.$emit('closeDialog', false)
      setTimeout(() => {
        this.selected = null
      }, 500)
    },
  },
}
</script>

<template>
  <v-card color="#FFFFFF;" min-height="450px">
    <v-card-text>
      <!-- close button -->
      <div :class="$style.closeButtonDiv">
        <v-btn
          color="offblack"
          :class="$style.closeButton"
          icon
          @click="closeDialog"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <!-- card dialog -->
      <template>
        <v-row justify="center">
          <v-col cols="12" md="10" sm="10">
            <div align="center" class="mt-3">
              <img
                width="350"
                height="230"
                :class="$style.logo"
                :src="
                  require('@assets/images/safehaven/SharingDocuments01.svg')
                "
              />
            </div>

            <v-row class="mt-2">
              <p :class="$style.headText"
                >You are about to share a temporary link to the documents you’ve
                selected.</p
              >
            </v-row>
            <v-row class="mt-2">
              <p :class="$style.subheadText"
                >The recipient will have limited access based on the number of
                days you choose.</p
              >
            </v-row>

            <!-- get started button -->
            <v-row no-gutters align="center" justify="center" class="mt-4">
              <v-btn
                :class="['primary-btn', $style.getStartedButton]"
                elevation="0"
                width="236"
                height="37"
                @click="getStarted"
                >Get Started</v-btn
              >
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
.logo {
  height: auto;
  padding-top: 0;
}
.closeButton {
  position: absolute;
  top: 20px;
  right: 0;
  padding-left: 0;
}
.closeButtonDiv {
  position: relative;
}

.headText {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  color: #454648;
}

.subheadText {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}

.getStartedButton {
  align-items: center !important;
  justify-content: center !important;
  width: 376px !important;
  height: 50px !important;
  border-radius: 30px;
}
@media screen and (max-width: 1263px) {
  .getStartedButton {
    top: 270px;
    width: 340px !important;
    height: 50px !important;
  }
}
@media screen and (max-width: 960px) {
  .getStartedButton {
    top: 150px;
    width: 340px !important;
    height: 50px !important;
  }
  .headText {
    margin-left: 20px !important;
  }
  .subheadText {
    margin-left: 20px !important;
  }
  .logo {
    margin-top: 100px !important;
  }
}
@media screen and (max-width: 599px) {
  .getStartedButton {
    top: 150px;
    width: 340px !important;
    height: 50px !important;
  }
}
</style>
